import { Action } from 'redux';
import { ContractBranch } from '../../../models/Entities/Contracts/ContractBranch';
import { ContractBranchState, ContractBranchUnloadState } from '../../states/ContractBranchState';


export default function ContractBranchesUpdateReducer(
  state: ContractBranchState | undefined,
  action: Action
): ContractBranchState {
  const currentState = state ?? ContractBranchUnloadState;
  const a: any = action;
  let CurrentBranchContract: ContractBranch | undefined;

  switch (a.type) {
    case 'CONTRACTBRANCH_UPDATE_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingNewOne: true,
        isUpdatedSuccessfully: undefined,
        failOnUpdatingNewOne: false,
      };
    
    case 'CONTRACTBRANCH_UPDATE_RECEIVE_ACTION':
      return {
        ...currentState,
        isUpdatingNewOne: false,
        isUpdatedSuccessfully: true,
        failOnUpdatingNewOne: false,
      };
    
    case 'CONTRACTBRANCH_UPDATE_ERROR_ACTION':
      return {
        ...currentState,
        isUpdatingNewOne: false,
        isUpdatedSuccessfully: false,
        failOnUpdatingNewOne: true,
        error: a.error,
      };
    
    default:
      return currentState;
  }
}
